import { Chapter } from "./chapter.model";

class Objective {
  constructor(
    public name: string = "",
    public description: string = "",
    public materials?: any[],
    public required?: boolean,
    public learningObjective?: string | any,
    public predecessorId?: string,
    public id?: string,
    public chapters?: Chapter[],
    public existsQuiz?: boolean

  ) {}
}

class InfoObjective {
  constructor(
    public id?: string,
    public name?: string,
    public description?: string,
    public required?: boolean,
    public learningObjective?: any
  ) {}
}

enum ObjectiveType {
  REQUIRED = "REQUIRED",
  SUPPLEMENTARY = "SUPPLEMENTARY",
}

export { Objective, ObjectiveType, InfoObjective };
